// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"6fe7b3ec9b40eea6a819","201":"e3f8b389899032f887f9","243":"b9e49f0c4364bb5ead67","682":"42decabe499554162257","688":"d7b42df22642d8fc86a7","765":"85e2cb3a12e4732aa483","852":"821fc1a7037b5e8d2217"}[chunkId] + ".bundle.js";
};